/* Чистая модель формы «Карточки для маркетплейса» (план вехи 3, mcard-infog K-PM): поддержан ли контракт и какие значения выборов форма
   получает по умолчанию. Одна правда для родной формы (MCardOrderForm.tsx) и сервера движка шаблона (features/mcard/mcard-server.ts):
   заявка одной стороны воспроизводится другой с теми же входами (симметрия отката, I1). */
import type { StudioForm } from '../studio/studio-api';
import { enumOf, fieldOf, photoSlots, textOf, unsupportedFields, type ControlKey } from '../slides/product-model';

/** Контролы экрана: ключи, которые форма может публиковать */
export const MCARD_CONTROLS: ControlKey[] = ['text', 'name', 'advantages', 'outputs', 'photoCount', 'platform', 'wishes', 'photoSet', 'slidesStyle', 'videoMotion', 'descTone'];
const ENUMS: ControlKey[] = ['outputs', 'photoCount', 'platform', 'photoSet', 'slidesStyle', 'videoMotion', 'descTone'];

/** Контракт поддержан: экран тот же, фото товара, «Что сделать» и поле текста есть, типы известных полей совпадают, обязательных незнакомых нет. */
export function mcardContractSupported(form: StudioForm) {
  if (form.screen !== 'mcard' || unsupportedFields(form, MCARD_CONTROLS).length) return false;
  if (!photoSlots(form).length || !enumOf(form, 'outputs') || !(textOf(form, 'text') ?? textOf(form, 'name'))) return false;
  return MCARD_CONTROLS.every(control => {
    const field = fieldOf(form, control);
    if (!field) return true;
    return ENUMS.includes(control) ? field.type === 'enum' && !field.upload && field.values.length > 0 : field.type === 'text' && !field.upload;
  });
}

/** Входы родной формы до загрузки формы: все четыре работы и 8 фото (MCardOrderForm initialInputs) */
export const MCARD_INITIAL = { outputs: 'photos,slides,video,description', photo_count: '8' } as const;
/** Умолчания выборов (useProductDefaults родной формы): умолчание формы, затем умолчание спецификации */
export const MCARD_DEFAULTS: Array<[ControlKey, string[]]> = [
  ['platform', ['wb']],
  ['photoSet', ['cat']],
  ['slidesStyle', ['min']],
  ['videoMotion', ['101']],
  ['descTone', ['sell']],
];
